export function Accordion(element: any, multiple: any) {
    let accChild = element
        .closest('[data-accordion-section]')
        .querySelectorAll('[data-accordion-item]');
    let accItem = element.closest('[data-accordion-item="item"]');
    let contentHeight = element.nextElementSibling.scrollHeight;

    // True - Open Multiple Accordion
    if (multiple == 'true') {
        if (accItem.classList.contains('active')) {
            element.nextElementSibling.style.maxHeight = '0';
            accItem.classList.remove('active');
        } else {
            accItem.classList.add('active');
            element.nextElementSibling.style.maxHeight =
                '' + contentHeight + 'px';
        }
    } else {
        // Open Single Accordion
        if (accItem.classList.contains('active')) {
            element.nextElementSibling.style.maxHeight = '0';
            accItem.classList.remove('active');
        } else {
            accChild?.forEach((el: any) => {
                el.classList.remove('active');
                el.querySelector(
                    '[data-accordion-content="content"]'
                ).style.maxHeight = '0';
            });
            accItem.classList.add('active');
            element.nextElementSibling.style.maxHeight =
                '' + contentHeight + 'px';
        }
    }
}

export function ngxScrollBor() {
    if (typeof window != 'undefined') {
        let element = document.querySelectorAll('.ng-scroll-viewport');
        if (element) {
            element.forEach((ele: any) => {
                ele.scrollTo(0, 0);
            })
        }
    }
}
